import { createVuetify } from 'vuetify'
import 'vuetify/styles'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

export default createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        dark: false,
        colors: {
          primary: '#075E54',
          secondary: '#128C7E',
          accent: '#25D366',
          error: '#CF6679',
          warning: '#F39C3D',
          info: '#7BA7E7',
          success: '#25D366',
          background: '#F0F2F5',
          surface: '#FFFFFF'
        }
      }
    }
  }
})
